/**
 * 判断是否 url
 * */
export function isUrl(url: string) {
  return /(^http|https:\/\/)/g.test(url);
}
/**
 * @description: 是否客户端
 */
export const isClient = () => {
  return typeof window !== 'undefined';
};

export const isServer = typeof window === 'undefined';

export default {
  isUrl,
  isClient,
  isServer,
};
